/**
 * The font stacks behind the Appearance Studio's family picker.
 *
 * Shared because two surfaces resolve the same choice: the widget preview
 * (`WidgetStage`) and, at the "full" white-label level, the operator console
 * itself (`white-label-chrome`). One map keeps a tenant's widget and their
 * dashboard from landing on different faces for the same setting.
 */
import type { WidgetAppearanceExtras } from "./api.ts";

export type FontFamilyId = WidgetAppearanceExtras["typography"]["font"];

export const FONT_STACKS: Record<FontFamilyId, string> = {
  system: '-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,sans-serif',
  geist: '"Geist",-apple-system,sans-serif',
  display: '"Bricolage Grotesque","Geist",sans-serif',
  serif: 'Georgia,"Iowan Old Style",Times,serif',
  rounded: 'ui-rounded,"Segoe UI Variable","Segoe UI",sans-serif',
  mono: '"JetBrains Mono",ui-monospace,monospace',
};

export function fontStack(font: string): string {
  return FONT_STACKS[font as FontFamilyId] ?? FONT_STACKS.geist;
}
